import { Column, GridRow } from '@shared';
import { IChangeset } from '@shared-data';
import { IAvailabilityItem } from './availability-item.interface';
import { DatePipe } from '@angular/common';

class ModifierAvailabilityChangeset implements IChangeset, IAvailabilityItem {
  id: string;
  restaurantId: number;
  restaurantNo: string;

  categoryId?: string;
  status?: string;

  @Column({
    field: 'categoryName',
    title: 'Category',
    order: 0,
    width: 150,
    sortable: true,
    hidden: true,
    filterable: true,
    filterType: 'text',
    align: 'left',
  })
  categoryName?: string;

  @Column({
    field: 'parItemId',
    title: 'Brink ID',
    order: 2,
    width: 150,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  parItemId: string;

  @Column({
    field: 'plu',
    title: 'PLU',
    order: 2,
    width: 150,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  plu?: string;

  @Column({
    field: 'itemName',
    title: 'Product',
    order: 1,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName: string;

  @Column({
    field: 'isActive',
    title: 'Current In Store/Delivery Availability',
    order: 5.94,
    width: 150,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: true,
    hidden: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  isActive?: boolean;

  @Column({
    field: 'newAvailability',
    title: 'In Store Availability',
    order: 5.94,
    width: 150,
    editable: true,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: true,
  })
  newAvailability?: boolean;

  availabilityScheduledDate: Date | null;

  pricingScheduledDate: Date | null;

  type: string = 'pricing';

  deliveryAvailability1P?: boolean = false;
  deliveryAvailability3P?: boolean = false;

  // @Column({
  //   field: 'newDeliveryAvailability1P',
  //   title: 'New 1P Delivery Availability',
  //   order: 13,
  //   type: 'boolean',
  //   editable: true,
  //   width: 90,
  //   filterType: 'boolean',
  //   filterable: true,
  //   visibleInQuickView: true,
  //   filterOptions: [
  //     { name: 'Available', value: true },
  //     { name: 'Not Available', value: false },
  //   ],
  // })
  newDeliveryAvailability1P?: boolean;

  @Column({
    field: 'newDeliveryAvailability3P',
    title: 'App/Delivery Availability',
    order: 13,
    type: 'boolean',
    editable: true,
    width: 90,
    filterType: 'boolean',
    filterable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newDeliveryAvailability3P?: boolean;

  @Column({
    field: 'lastModAvailInstore',
    hidden: true,
    title: 'Last Modified Availability In-Store',
    order: 14,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModAvailInstore?: Date;

  @Column({
    field: 'lastModAvailDelivery',
    hidden: true,
    title: 'Last Modified Availability Delivery',
    order: 15,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModAvailDelivery?: Date;

  constructor(changeset?: Partial<ModifierAvailabilityChangeset>) {
    this.id = changeset?.id || '';
    this.restaurantId = changeset?.restaurantId ?? 0;
    this.restaurantNo = changeset?.restaurantNo ?? '';
    this.itemName = changeset?.itemName ?? '';
    this.isActive = changeset?.isActive;
    this.newAvailability =
      changeset?.newAvailability !== null
        ? changeset?.newAvailability
        : changeset.isActive;
    this.deliveryAvailability1P = changeset?.deliveryAvailability1P;
    this.deliveryAvailability3P = changeset?.deliveryAvailability3P;
    this.newDeliveryAvailability1P =
      changeset?.newDeliveryAvailability1P !== null
        ? changeset?.newDeliveryAvailability1P
        : changeset.deliveryAvailability1P;
    this.newDeliveryAvailability3P =
      changeset?.newDeliveryAvailability3P !== null
        ? changeset?.newDeliveryAvailability3P
        : changeset.deliveryAvailability3P;
    this.categoryId = changeset?.categoryId;
    this.parItemId = changeset?.parItemId ?? '';
    this.plu = changeset?.plu;
    this.availabilityScheduledDate =
      changeset?.availabilityScheduledDate ?? null;
    this.pricingScheduledDate = changeset?.pricingScheduledDate ?? null;
    this.categoryName = changeset?.categoryName;
    this.status = changeset?.status;
    this.lastModAvailDelivery = changeset?.lastModAvailDelivery;
    this.lastModAvailInstore = changeset?.lastModAvailInstore;
  }
}
export class GridRowModifierAvailabilityChangeset extends GridRow(
  ModifierAvailabilityChangeset
) {}
